import * as types from '../constants/oemConstants';

// Get OEM Partners
export const getOemPartnersRequest = () => ({
  type: types.GET_OEM_PARTNERS_REQUEST,
});

export const getOemPartnersSuccess = (data) => ({
  type: types.GET_OEM_PARTNERS_SUCCESS,
  payload: data,
});

export const getOemPartnersFailure = (error) => ({
  type: types.GET_OEM_PARTNERS_FAILURE,
  payload: error,
});

export const getOemPartners = (params) => ({
  type: types.GET_OEM_PARTNERS_REQUEST,
  payload: params,
});

// Add OEM Partner
export const addOemPartnerRequest = () => ({
  type: types.ADD_OEM_PARTNER_REQUEST,
});

export const addOemPartnerSuccess = (data) => ({
  type: types.ADD_OEM_PARTNER_SUCCESS,
  payload: data,
});

export const addOemPartnerFailure = (error) => ({
  type: types.ADD_OEM_PARTNER_FAILURE,
  payload: error,
});

export const addOemPartner = (partnerData) => ({
  type: types.ADD_OEM_PARTNER_REQUEST,
  payload: partnerData,
});

// Edit OEM Partner
export const editOemPartnerRequest = () => ({
  type: types.EDIT_OEM_PARTNER_REQUEST,
});

export const editOemPartnerSuccess = (data) => ({
  type: types.EDIT_OEM_PARTNER_SUCCESS,
  payload: data,
});

export const editOemPartnerFailure = (error) => ({
  type: types.EDIT_OEM_PARTNER_FAILURE,
  payload: error,
});

export const editOemPartner = (partnerData) => ({
  type: types.EDIT_OEM_PARTNER_REQUEST,
  payload: partnerData,
});

// Delete OEM Partner
export const deleteOemPartnerRequest = () => ({
  type: types.DELETE_OEM_PARTNER_REQUEST,
});

export const deleteOemPartnerSuccess = (data) => ({
  type: types.DELETE_OEM_PARTNER_SUCCESS,
  payload: data,
});

export const deleteOemPartnerFailure = (error) => ({
  type: types.DELETE_OEM_PARTNER_FAILURE,
  payload: error,
});

export const deleteOemPartner = (params) => ({
  type: types.DELETE_OEM_PARTNER_REQUEST,
  payload: params,
});

// Change OEM Status
export const changeOemStatusRequest = () => ({
  type: types.CHANGE_OEM_STATUS_REQUEST,
});

export const changeOemStatusSuccess = (data) => ({
  type: types.CHANGE_OEM_STATUS_SUCCESS,
  payload: data,
});

export const changeOemStatusFailure = (error) => ({
  type: types.CHANGE_OEM_STATUS_FAILURE,
  payload: error,
});

export const changeOemStatus = (params) => ({
  type: types.CHANGE_OEM_STATUS_REQUEST,
  payload: params,
});

// Get Scan Types
export const getScanTypesRequest = () => ({
  type: types.GET_SCAN_TYPES_REQUEST,
});

export const getScanTypesSuccess = (data) => ({
  type: types.GET_SCAN_TYPES_SUCCESS,
  payload: data,
});

export const getScanTypesFailure = (error) => ({
  type: types.GET_SCAN_TYPES_FAILURE,
  payload: error,
});

export const getScanTypes = () => ({
  type: types.GET_SCAN_TYPES_REQUEST,
});

// Get OEM Partner Names
export const getOemPartnerNamesRequest = () => ({
  type: types.GET_OEM_PARTNER_NAMES_REQUEST,
});

export const getOemPartnerNamesSuccess = (data) => ({
  type: types.GET_OEM_PARTNER_NAMES_SUCCESS,
  payload: data,
});

export const getOemPartnerNamesFailure = (error) => ({
  type: types.GET_OEM_PARTNER_NAMES_FAILURE,
  payload: error,
});

export const getOemPartnerNames = (almataId) => ({
  type: types.GET_OEM_PARTNER_NAMES_REQUEST,
  payload: almataId,
});

// Get OEM Partner Users
export const getOemPartnerUsersRequest = () => ({
  type: types.GET_OEM_PARTNER_USERS_REQUEST,
});

export const getOemPartnerUsersSuccess = (data) => ({
  type: types.GET_OEM_PARTNER_USERS_SUCCESS,
  payload: data,
});

export const getOemPartnerUsersFailure = (error) => ({
  type: types.GET_OEM_PARTNER_USERS_FAILURE,
  payload: error,
});

export const getOemPartnerUsers = (params) => ({
  type: types.GET_OEM_PARTNER_USERS_REQUEST,
  payload: params,
});